module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', [_vm._v("背景色用法:")]), _vm._v(" "), _c('div', {
    staticClass: "padding30 bg-blue align-center fg-white"
  }, [_vm._v("\n        background: blue\n    ")]), _vm._v(" "), _c('div', [_c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<div class=\"bg-blue\">\n   background: blue\n</div>\n")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', {
    staticClass: "no-margin"
  }, [_vm._v("字体颜色:")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', [_c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<p class=\"fg-blue\">blue</p>\n<p class=\"fg-orange\">orange</p>\n<p class=\"fg-emerald\">emerald</p>\n")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "box flex-grid"
  }, [_c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Metro colors 主色系")]), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("\n        下面列出来的颜色可以用来充当背景色或文字颜色:\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("背景颜色: "), _c('span', {
    staticClass: "tag info"
  }, [_vm._v("bg-*")])]), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("字体颜色: "), _c('span', {
    staticClass: "tag info"
  }, [_vm._v("fg-*")])]), _vm._v(" "), _c('ul', {
    staticClass: "row unstyled-list"
  }, [_c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-black"
  }, [_vm._v("black")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-white"
  }, [_vm._v("white")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-lime"
  }, [_vm._v("lime")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-green"
  }, [_vm._v("green")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-emerald"
  }, [_vm._v("emerald")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-teal"
  }, [_vm._v("teal")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-blue"
  }, [_vm._v("blue")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-cyan"
  }, [_vm._v("cyan")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-cobalt"
  }, [_vm._v("cobalt")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-indigo"
  }, [_vm._v("indigo")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-violet"
  }, [_vm._v("violet")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-pink"
  }, [_vm._v("pink")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-magenta"
  }, [_vm._v("magenta")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-crimson"
  }, [_vm._v("crimson")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-red"
  }, [_vm._v("red")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-orange"
  }, [_vm._v("orange")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-amber"
  }, [_vm._v("amber")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-yellow"
  }, [_vm._v("yellow")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-brown"
  }, [_vm._v("brown")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-olive"
  }, [_vm._v("olive")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-steel"
  }, [_vm._v("steel")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-mauve"
  }, [_vm._v("mauve")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-taupe"
  }, [_vm._v("taupe")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-gray"
  }, [_vm._v("gray")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-dark"
  }, [_vm._v("dark")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-darker"
  }, [_vm._v("darker")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-darkBrown"
  }, [_vm._v("darkBrown")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-darkCrimson"
  }, [_vm._v("darkCrimson")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-darkMagenta"
  }, [_vm._v("darkMagenta")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-darkIndigo"
  }, [_vm._v("darkIndigo")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-darkCyan"
  }, [_vm._v("darkCyan")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-darkCobalt"
  }, [_vm._v("darkCobalt")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-darkTeal"
  }, [_vm._v("darkTeal")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-darkEmerald"
  }, [_vm._v("darkEmerald")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-darkGreen"
  }, [_vm._v("darkGreen")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-darkOrange"
  }, [_vm._v("darkOrange")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-darkRed"
  }, [_vm._v("darkRed")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-darkPink"
  }, [_vm._v("darkPink")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-darkViolet"
  }, [_vm._v("darkViolet")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-darkBlue"
  }, [_vm._v("darkBlue")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-lightBlue"
  }, [_vm._v("lightBlue")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-lightRed"
  }, [_vm._v("lightRed")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-lightGreen"
  }, [_vm._v("lightGreen")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-lighterBlue"
  }, [_vm._v("lighterBlue")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-lightTeal"
  }, [_vm._v("lightTeal")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-lightOlive"
  }, [_vm._v("lightOlive")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-lightOrange"
  }, [_vm._v("lightOrange")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-lightPink"
  }, [_vm._v("lightPink")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-grayDark"
  }, [_vm._v("grayDark")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-grayDarker"
  }, [_vm._v("grayDarker")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-grayLight"
  }, [_vm._v("grayLight")]), _vm._v(" "), _c('li', {
    staticClass: "padding10 cell colspan2 align-center text-shadow fg-white bg-grayLighter"
  }, [_vm._v("grayLighter")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "fg-blue"
  }, [_vm._v("blue")]), _vm._v(" "), _c('p', {
    staticClass: "fg-orange"
  }, [_vm._v("orange")]), _vm._v(" "), _c('p', {
    staticClass: "fg-emerald"
  }, [_vm._v("emerald")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c031e61"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helper/color.vue
// module id = 389
// module chunks = 1